import {Component, OnInit, Input}                                    from '@angular/core';
import {FormBuilder, FormGroup, Validators, AbstractControl}         from '@angular/forms';
import {Api}                                                         from '../../shared/api.service';
import {Observable}                                                  from 'rxjs';
import {updatedDiff}                                                 from 'deep-object-diff';
import {RequestLog}                                                  from '../../shared/api/requestlog.model';
import {Router}                                                      from '@angular/router';
import {ContactMomentSettings, SchemaSettings}                       from './schema.models';
import {Schema}                                                      from '../../shared/api/bases/proxy/schemas/schema.interface';
import {ContactMoment}                                               from '../../shared/api/bases/proxy/schemas/contactMoments/api.models';
import {MessageCollection}                                           from '../../shared/api/messages/api.models';
import {Schemas}                                                     from '../../shared/api/bases/proxy/schemas/schemas.interface';
import {Base}                                                        from '../../shared/api/bases/api.models';

enum States {
    QUEUED,
    SAVING,
    SAVED,
    FAILED
}

@Component({
    selector : 'schema',
    template: require('./schema.component.html'),
    styles: [require('./schema.component.scss')]
})

export class SchemaComponent implements OnInit {
    @Input()
    public base: Base;

    @Input()
    public schema: Schema = {} as Schema;

    @Input()
    public moments: ContactMoment[] = [];

    @Input()
    public settings: SchemaSettings;

    public workingSchema: any;
    public schemaForm: FormGroup;
    public priorities: number[] = [];
    public durations: number[] = [];
    public contactMomentDays: any[] = [];
    public minutes: any[] = [];
    public schemaNameInUse: boolean = false;

    public contactMoments: any = {
        relative: {
            isValid          : false,
            componentMoments : [],
            apiMoments       : [],
            settings         : {}
        },
        absolute: {
            isValid          : true,
            componentMoments : [],
            apiMoments       : [],
            settings         : {}
        }
    };

    public messageTagOptions      = MessageCollection.tags;
    public messageTags : any[]    = ["default"];
    public senderTagOptions       = MessageCollection.tags;
    public senderTags : any[]     = ["default"];
    public metadataValid: boolean = false;
    public sections = {
        properties     : true,
        contactMoments : true,
        filters        : true
    };

    public states = States;

    public saveState: any;

    protected storedContactMoments  : ContactMoment[] = [];

    protected rawResponses: any[] = [];
    protected filters: any;

    protected originalSettings: SchemaSettings;
    protected originalContactMoments: ContactMoment[] = [];
    protected originalContactMomentsHash: any = {};
    protected originalSchema:  Schema;

    protected schemas: Schema[] = [];


    constructor(private fb: FormBuilder, private api: Api, private router: Router) {}

    ngOnInit() {
        this.originalSettings = this.settings ? Object.assign({}, this.settings) : new SchemaSettings();
        this.originalSchema   = this.schema   ? Object.assign({}, this.schema)   : {
            id : null,
            name : '',
            nextSchemaId: null,
            isActive : false,
            priority : 100,
            duration : null,
            metadata : {},
            profileFilters : {}
        } as Schema;

        this.contactMoments.relative.settings = Object.assign({}, this.settings, {allDaysRequired : true}) as ContactMomentSettings;
        this.contactMoments.absolute.settings = Object.assign({}, this.settings, {allDaysRequired : false}) as ContactMomentSettings;

        this.moments.forEach((moment: ContactMoment) => {
            this.originalContactMoments.push(Object.assign({}, moment));

            if (this.settings.treatAsNew === false) {
                this.originalContactMomentsHash[moment.id] = this.originalContactMoments[this.originalContactMoments.length - 1];
            }
        });

        this.api.bases().proxy(this.base.id).schemas().collection(1, 1000).subscribe((schemas: Schemas) => {
            schemas.result.forEach((schema: Schema) => {
                if (schema.id !== this.originalSchema.id) {
                    this.schemas.push(schema);
                }
            });
        });

        this.resetState();
    }

    toggleSection(section) {
        this.sections[section] = !this.sections[section];
    }

    momentsChanged(event: any, type: string) {
        this.contactMoments[type].isValid          = event.isValid;
        this.contactMoments[type].componentMoments = event.moments;
    }

    filtersChanged(event: any) {
        this.filters = event;
    }

    messageTagsChanged() {
        this.determineMetadataSettings();
    }

    private determineMetadataSettings() {
        this.metadataValid = false;

        if (this.messageTags.length > 0) {
            this.metadataValid = true;
        }
    }

    save(): boolean {
        this.resetSaveState();
        this.api.clearRequestLog();



        Observable.create((mainObservable) => {
            var schema: any;

            this.saveState.state = States.SAVING;

            if (this.schema.id) {
                schema = updatedDiff(this.schema, this.workingSchema);
            } else {
                schema = this.workingSchema;
            }

            schema.profileFilters = this.filters;
            schema.metadata       = {
                message : {
                    tags: this.messageTags
                },
                sender : {
                    tags: this.senderTags
                }
            };

            var observable;
            if (this.schema.id) {
                observable  = this.api.bases().proxy(this.base.id).schemas().update(this.schema.id, schema);
            } else {
                observable = this.api.bases().proxy(this.base.id).schemas().add(schema);
            }

            observable.subscribe(
                (schema: Schema) => {
                    var list = [];
                    var idList: string[] = [];
                    var deleteList: number[] = [];

                    this.schema = schema;

                    this.rawResponses.push(schema);
                    this.saveState.schema.state = States.SAVED;

                    ['absolute', 'relative'].forEach((type: string) => {
                        this.contactMoments[type].componentMoments.forEach((contactMoment) => {
                            contactMoment.messages.forEach((message, index) => {
                                var apiContactMoment = new ContactMoment();

                                apiContactMoment.id             = message.days[message.daySet].id;
                                apiContactMoment.parentId       = message.days[message.daySet].parentId;
                                apiContactMoment.schemaId       = schema.id;
                                apiContactMoment.dayNr          = message.daySet + 1;
                                apiContactMoment.timeHour       = message.days[message.daySet].hour;
                                apiContactMoment.timeMinute     = message.days[message.daySet].minute;
                                apiContactMoment.deviation      = contactMoment.deviation;
                                apiContactMoment.isAbsoluteTime = (type === 'absolute');
                                apiContactMoment.contactFilters = {
                                    messageType      : contactMoment.type,
                                    firstMessageType : contactMoment.firstMessageType,
                                    behaviour        : contactMoment.behaviour || null,
                                    attachmentType   : contactMoment.attachment || null,
                                    chainLength      : contactMoment.messages.length,
                                    messageNr        : index
                                };

                                // Create patch file when id is provided
                                if (apiContactMoment.id) {
                                    idList.push(apiContactMoment.id + '');

                                    apiContactMoment = updatedDiff(this.originalContactMomentsHash[apiContactMoment.id], apiContactMoment) as ContactMoment;

                                    if (JSON.stringify(apiContactMoment) === '{}') {
                                        return;
                                    }

                                    apiContactMoment.id       = message.days[message.daySet].id;
                                    apiContactMoment.parentId = message.days[message.daySet].parentId;
                                }

                                list.push(apiContactMoment);
                            });
                        });
                    });


                    if (this.settings.treatAsNew === false) {
                        for (let i in this.originalContactMoments) {
                            if (this.originalContactMoments[i].id && idList.indexOf(this.originalContactMoments[i].id.toString()) === -1) {
                                deleteList.unshift(this.originalContactMoments[i].id);    // Start with newest moments first
                            }
                        }
                    }

                    if (deleteList.length > 0) {
                        this.deleteContactMoments(deleteList, schema).subscribe(
                            (response) => {
                                this.rawResponses.push(response);
                                this.saveState.momentsRemoved.state = States.SAVED;

                                if (list.length > 0) {
                                    this.storeContactMomentMessages(list, schema).subscribe(
                                        (response) => {
                                            this.rawResponses.push(response);
                                            this.saveState.momentsSaved.state = States.SAVED;
                                            mainObservable.next();
                                        },
                                        (response) => {
                                            this.rawResponses.push(response);
                                            this.saveState.momentsSaved.state = States.FAILED;
                                            mainObservable.error(response);
                                        }
                                    );
                                } else {
                                    this.saveState.momentsSaved.state = States.SAVED;
                                    mainObservable.next();
                                }
                            },
                            (response) => {
                                this.rawResponses.push(response);
                                this.saveState.momentsRemoved.state = States.FAILED;
                                mainObservable.error(response);
                            }
                        );
                    } else {
                        this.saveState.momentsRemoved.state = States.SAVED;

                        if (list.length > 0) {
                            this.storeContactMomentMessages(list, schema).subscribe(
                                (response) => {
                                    this.rawResponses.push(response);
                                    this.saveState.momentsSaved.state = States.SAVED;
                                    mainObservable.next();
                                },
                                (response) => {
                                    this.rawResponses.push(response);
                                    this.saveState.momentsSaved.state = States.FAILED;
                                    mainObservable.error(response);
                                }
                            );
                        } else {
                            this.saveState.momentsSaved.state = States.SAVED;
                            mainObservable.next();
                        }
                    }
                },
                (response) => {
                    this.rawResponses.push(response);
                    this.saveState.schema.state = States.FAILED;
                    mainObservable.error(response);
                }
            );
        }).subscribe(
            () => {
                this.saveState.state = States.SAVED;
            },
            () => {
                this.saveState.state = States.FAILED;

                if (this.originalSchema.id === null && this.schema.id !== null) {
                    this.api.bases().proxy(this.base.id).schemas().remove(this.schema.id).subscribe();
                    this.schema.id = null;
                }
            }
        );

        return false;
    }

    edit(): void {
        this.resetSaveState();
    }

    continue(): void {
        this.router.navigate(['/schemas/overview']);
    }

    sendDebugInformation(event: Event) {
        event.preventDefault();

        let addBreak = function(char: string): string {
            message = '';

            for (let i = 0; i < 40; i++) {
                message += char;
            }

            return message + "\n";
        };


        var message = "Dear support,\n\n Minima could not store the following information:\n\n";


        message += "Request(s) made\n" + addBreak('=');
        this.api.getRequestLog().forEach((log: RequestLog) => {
            message += "Request:  [" + log.method + "] " + log.url + "\n";
            message += "Body:     " + JSON.stringify(log.requestBody) + "\n";
            message += "Response: [" + log.responseCode + "] " + JSON.stringify(log.responseBody) + "\n";
            message += addBreak('-');
        });

        message += "\n\nResources:\n" + addBreak('=');
        message += "Schema:  " + JSON.stringify(this.workingSchema) + "\n";
        message += "Filters: " + JSON.stringify(this.filters) + "\n";
        message += "Moments: " + JSON.stringify(this.contactMoments) + "\n";

        message += "\n\nBest regards,\n\n Minima";

        window.open(
            encodeURI('mailto:support@project89109.nl?subject=[minima] - Could not store schema&body=' + message),
            '_self'
        );

        return false;
    }

    private deleteContactMoments(contactMomentIds: number[], schema, previousObservable?) {
        if (contactMomentIds.length === 0) {
            return previousObservable;
        }

        var observable;
        let id = contactMomentIds[0];

        contactMomentIds.shift();

        if (previousObservable) {
            observable = previousObservable.flatMap(() => {
                return this.api.bases().proxy(this.base.id).schemas().contactMoments(schema.id).remove(id).do(() => this.saveState.momentsRemoved.count += 1);
            });
        } else {
            observable = this.api.bases().proxy(this.base.id).schemas().contactMoments(schema.id).remove(id).do(() => this.saveState.momentsRemoved.count += 1);
        }

        return this.deleteContactMoments(contactMomentIds, this.schema, observable);
    }

    private storeContactMomentMessages(contactMoments: ContactMoment[], schema: Schema, previousObservable?) {
        if (contactMoments.length === 0) {
            return previousObservable;
        }

        let contactMoment = contactMoments[0];

        if ( contactMoment.contactFilters && contactMoment.contactFilters.messageType === undefined ) {
            contactMoment.contactFilters.messageType = null;
        }

        contactMoments.splice(0, 1);

        var observable;
        let hasParent = !!contactMoment.parentId;

        if (previousObservable) {
            // flatMap will execute the requests in order and wait till other one is completed
            observable = previousObservable.flatMap(() => {
                var anObservable;

                if (contactMoment.id) {
                    anObservable = this.api.bases().proxy(this.base.id).schemas().contactMoments(schema.id).update(contactMoment.id, contactMoment);
                } else {
                    if (hasParent === false && contactMoment.contactFilters.messageNr > 0) {
                        contactMoment.parentId = this.storedContactMoments[this.storedContactMoments.length - 1].id;
                    }

                    anObservable = this.api.bases().proxy(this.base.id).schemas().contactMoments(schema.id).add(contactMoment);
                }

                return anObservable.do((response: ContactMoment) => {
                    this.storedContactMoments.push(response);
                    this.saveState.momentsSaved.count += 1
                });
            });
        } else {
            if (contactMoment.id) {
                observable = this.api.bases().proxy(this.base.id).schemas().contactMoments(schema.id).update(contactMoment.id, contactMoment);
            } else {
                observable = this.api.bases().proxy(this.base.id).schemas().contactMoments(schema.id).add(contactMoment)
            }

            observable = observable.do((response: ContactMoment) => {
                this.storedContactMoments.push(response);
                this.saveState.momentsSaved.count += 1
            });
        }

        return this.storeContactMomentMessages(contactMoments, schema, observable);
    }

    private resetState(): void {
        this.determineMetadataSettings();
        this.resetSaveState();

        this.priorities = [];
        this.durations  = [];
        this.minutes    = [];

        for (let i = 100; i >= 1; i--) {
            this.priorities.push(i);
        }

        for (let i = 1; i <= 7; i++) {
            this.durations.push(i);
        }

        for (let i = 0; i <= 60; i++) {
            this.minutes.push(i);
        }

        this.settings = Object.assign({}, this.originalSettings);
        this.schema   = Object.assign({}, this.originalSchema);

        this.contactMoments.absolute.apiMoments = [];
        this.contactMoments.relative.apiMoments = [];

        this.originalContactMoments.forEach((moment: ContactMoment) => {
            if (moment.isAbsoluteTime === true) {
                this.contactMoments.absolute.apiMoments.push(Object.assign({}, moment));
            } else {
                this.contactMoments.relative.apiMoments.push(Object.assign({}, moment));
            }
        });

        if (this.settings.treatAsNew === true) {
            this.schema.id       = null;
            this.schema.isActive = false;
            this.schema.name     = null;
            this.schema.hasEverBeenActive = false;
            this.schema.metadata = {};
        }

        this.schemaForm = this.fb.group({
            id   : [this.schema.id],
            name : [
                this.schema.name,
                [
                    Validators.required,
                    Validators.minLength(5),
                    Validators.maxLength(50),
                    Validators.pattern(/^[0-9a-zA-Z\s\-]+$/)
                ],
                [
                    (c: AbstractControl) => {
                        // @TODO Add debouncing
                        return new Observable(observer => {
                            this.api.bases().proxy(this.base.id).schemas().collection(1, 1, c.value).subscribe(
                                (result: Schemas) => {
                                    if (result.pagination.total === 0 ||(this.schema.name && this.schema.name.trim() === c.value.trim())) {
                                        this.schemaNameInUse = false;
                                        observer.next(null);
                                    } else {
                                        this.schemaNameInUse = true;
                                        observer.next({invalid : true});
                                    }
                                }
                            )
                        }).first();
                    }
                ]
            ],
            nextSchemaId : [this.schema.nextSchemaId, []],
            isActive     : [this.schema.isActive ? '1' : '0', [Validators.required]],
            priority     : [this.schema.priority, [Validators.required]],
            duration     : [this.schema.duration, [Validators.required]]
        });

        this.filters = this.schema.profileFilters;
        if (this.schema.metadata && 'message' in this.schema.metadata && 'tags' in this.schema.metadata.message) {
            this.messageTags = this.schema.metadata.message.tags;
        }

        if (this.schema.metadata && 'sender' in this.schema.metadata && 'tags' in this.schema.metadata.sender) {
            this.senderTags = this.schema.metadata.sender.tags;
        }

        this.workingSchema            = this.schemaForm.value;
        this.workingSchema.isActive   = this.schemaForm.controls['isActive'].value === '1';

        this.schemaForm.valueChanges.subscribe((schema: any) => {
            this.workingSchema              = schema;
            this.workingSchema.isActive     = schema.isActive === '1';
            this.workingSchema.nextSchemaId = schema.nextSchemaId === 'null' ? null : schema.nextSchemaId;
        });
    }

    private resetSaveState(): void {
        this.saveState = {
            state  : States.QUEUED,
            schema : {
                state : States.QUEUED
            },
            momentsRemoved : {
                state : States.QUEUED,
                count : 0
            },
            momentsSaved : {
                state : States.QUEUED,
                count : 0
            }
        };
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/components/schema.component.ts